import {
  Alert as ChakraAlert,
  AlertProps,
  Box,
  useDisclosure,
} from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

import {
  IconCheckmarkLarge,
  IconError,
  IconInfo,
} from '../../../../../common/design-tokens/Icons';
import CloseButton from '../../../_atoms/Button/CloseButton';
import SVGWrapper from '../../../_atoms/Utility/SVGWrapper';

type NoticeStatus = 'info' | 'warning' | 'success' | 'error';

interface Props extends AlertProps {
  children: ReactNode;
  hideClose?: boolean;
  onClose?: () => void;
  status?: NoticeStatus;
  fullWidth?: boolean;
}

const StatusConfig: {
  [K in NoticeStatus]: {
    styles?: { [key: string]: string };
    icon: ReactElement;
  };
} = {
  info: {
    icon: <IconInfo />,
  },
  warning: {
    icon: <IconInfo />,
  },
  success: {
    icon: <IconCheckmarkLarge />,
  },
  error: {
    icon: <IconError />,
  },
};

const Alert = ({
  children,
  onClose,
  status = 'info',
  fullWidth = false,
  hideClose = false,
  ...rest
}: Props) => {
  const { isOpen: isVisible, onClose: disclosureOnClose } = useDisclosure({
    defaultIsOpen: true,
  });

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    disclosureOnClose();
    onClose?.();
  };

  return (
    <ChakraAlert
      status={status}
      width={fullWidth ? '100%' : 'fit-content'}
      {...rest}
    >
      {StatusConfig[status].icon ? (
        <Box mr={1}>
          <SVGWrapper icon={StatusConfig[status].icon} />
        </Box>
      ) : null}
      {children}
      {hideClose ? null : <CloseButton onClose={handleClose} />}
    </ChakraAlert>
  );
};

export default Alert;
